import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { DimensionSettingsFormProps } from "models/propTypes/settingsPropTypes";
//#endregion
//#region components
import { GenericForm } from "components/common";
//#endregion

const DimensionSettingsForm: ForwardRefRenderFunction<FormHandles, DimensionSettingsFormProps> = (props, ref) => {
  const { formGroup } = props;
  return <GenericForm<any> formRef={ref} inline {...props} fields={formGroup} />;
};

export default forwardRef(DimensionSettingsForm);
